import React, { useState } from 'react'

// import UISwitch from '../../../../components/UI/UISwitch'
import UIButton from '../../../../components/UI/UIButton'
import UIPasswordInput from '../../../../components/UI/UIPasswordInput'
import { Icon } from '../../../../components/Icon'
import { Accordion, AccordionItem } from '../../components/Accordion'
import { addNewPassword } from '../../../../api/settings.tsx/settings'
import { incidentData } from '../../../../utils/types'
import { toast } from 'react-toastify'
export interface password {
  oldPassword: string
  newPassword: string
}

const initialData = {
  oldPassword: '',
  newPassword: '',
}

const Account = () => {
  const [passwordData, setPasswordData] = useState(initialData)
  const createNewPassword = async (): Promise<void> => {
    const minLength = 8
    const hasSpecialSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(
      passwordData.newPassword
    )
    const hasUpperCase = /[A-Z]/.test(passwordData.newPassword)

    // Check conditions
    if (
      passwordData.newPassword.length < minLength ||
      !hasSpecialSymbol ||
      !hasUpperCase
    ) {
      // Password doesn't meet requirements, show toast
      toast.error(
        'Password must be at least 8 characters long and contain at least one special symbol and one uppercase letter.',
        {
          position: 'top-right',
        }
      )
      return // Exit function early if validation fails
    }
    try {
      const response = (await addNewPassword(passwordData)) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        toast.success('Passsowrd Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Password not matched', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('wrong password.', {
        position: 'top-right',
      })
    }
  }

  const handleChange = (fieldName: string, value: string): void => {
    setPasswordData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }
  // const handleSwitchChange = (value: boolean) => {
  //   setSwitchValue(value)
  // }

  return (
    <>
      <div className="flex my-8 gap-2">
        {/* First column */}
        <div className="flex flex-col w-8/12 gap-4">
          <div className="w-full p-4 bg-gray3 rounded-xl flex gap-2">
            <div className="mt-1">
              <Icon
                name={'IconInfoCircle'}
                width={16}
                height={16}
                stroke="#02698C"
                strokeWidth={1.2}
              />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold leading-6 text-text2">
                Your Profile
              </p>
              <p className="text-sm font-normal leading-6 text-bluishGreen">
                Your Account email and information is managed in your SCR Record
              </p>
            </div>
          </div>

          <Accordion defaultActiveIndex={0}>
            <AccordionItem title={'Password Reset'} isActive={false}>
              <div className="flex flex-col gap-4 mt-2 my-4 px-1">
                <div className="flex flex-col w-full gap-4">
                  <UIPasswordInput
                    onChange={(e) => {
                      handleChange('oldPassword', e.target.value)
                    }}
                    value={passwordData.oldPassword}
                    placeholder="Your old password"
                    label={'Old Password'}
                    iconName={'IconLock'}
                  />
                  <UIPasswordInput
                    placeholder="Your new password"
                    label={'New Password'}
                    onChange={(e) => {
                      handleChange('newPassword', e.target.value)
                    }}
                    value={passwordData.newPassword}
                    iconName={'IconLock'}
                    labelBottomList={[
                      `Length: Make your password at least 8 - 12 characters long.`,
                      `Mix It Up: Use a combination of uppercase and lowercase letters, numbers, and special characters.`,
                      `Avoid Common Patterns: Stay away from easy-to-guess sequences like "123456" or "password"`,
                      `No Personal Info: Don't use personal information like names or birthdays in your password. Keep your password strong and secure to protect your personal data!`,
                    ]}
                  />
                  <div className="w-[30%]">
                    <UIButton
                      label="Change"
                      type="button"
                      onClick={() => createNewPassword()}
                      disabled={passwordData.newPassword == ''}
                    />
                  </div>
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </>
  )
}

export default Account
